import React, { JSX } from 'react';
import { StyledModalWrapper } from './style';

type ModalType = {
  open: boolean;
  setOpen: (value: boolean) => void;
  children: JSX.Element | string;
  background?: string;
};
const Modal: React.FC<ModalType> = ({
  open,
  setOpen,
  background,
  children
}) => {
  return (
    <StyledModalWrapper background={background}>
      <div
        className={`backdrop${open ? '-active' : ''}`}
        onClick={() => setOpen(false)}>
        <div className="modal-content">{children}</div>
      </div>
    </StyledModalWrapper>
  );
};

export default Modal;
